import { render } from "./Event.vue?vue&type=template&id=5e65b385&scoped=true"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"

import "./Event.vue?vue&type=style&index=0&id=5e65b385&lang=scss&scoped=true"
import "./Event.vue?vue&type=style&index=1&id=5e65b385&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e65b385"]])

export default __exports__